import axiosInstance from '../../../lib/axios';
import type { VideoOperation } from '../types';

export interface PromptAssistInput {
  operation: VideoOperation;
  prompt: string;
  aspectRatio?: string;
  durationSeconds?: number;
  hasInputImage?: boolean;
}

/** Errors are shown inline by the button (402 needs a clear message), so no global toast. */
export async function improveVideoPrompt(input: PromptAssistInput): Promise<string> {
  const response = await axiosInstance.post('/v1/services/generate-video/prompt-assist', input, {
    skipErrorToast: true,
  });
  return response.data.data.prompt;
}
